import Vue from 'vue'

const parseQueryToggles = (queryObject = {}, queryStringPrefix = '') => Object.entries(queryObject)
  .filter(([key]) => key.startsWith(`${queryStringPrefix}_`))
  .reduce((toggles, [key, value]) => ({
    ...toggles,
    [key.replace(`${queryStringPrefix}_`, '')]: value
  }), {})

export default (ctx, inject) => {
  const { $config, route, app: { router } } = ctx
  const { toggles: _toggles, queryString: _queryString, queryStringPrefix } = JSON.parse(`{"toggles":{"extras_navigation":false,"job_application_landingpage_redirect":true,"job_application_landingpage_redirect_with_chatgpt":true,"job_posting_chatgpt_meta_data":true,"job_card_badge_top_organization":false,"job_card_badge_top_salary":false,"job_listing_filter_counter":false,"job_alerts":true,"profile_skills":false,"organization_question_dialog":false,"organization_question_dialog_in_listing":true,"profile_toogle_fields":false,"public_profile":false,"rating":true,"send_jobs_via_email":false,"videos":true,"show_jobs_as_published_for_visitors":false,"new_job_model_fields":true,"agency_portals":true},"queryString":true,"queryStringPrefix":"toggle"}`)
  const runtimeConfig = ($config && $config.featureToggle) || {}
  const queryString = typeof runtimeConfig.queryString !== 'undefined' ? runtimeConfig.queryString : _queryString
  let queryToggles = {}

  if (queryString) {
    if (router && route) {
      queryToggles = parseQueryToggles(route.query, queryStringPrefix)
      router.afterEach((to) => {
        featureToggle.toggles = {
          ..._toggles,
          ...(runtimeConfig.toggles || {}),
          ...parseQueryToggles(to.query, queryStringPrefix)
        }
      })
    }
  }
  const toggles = {
    ..._toggles,
    ...(runtimeConfig.toggles || {}),
    ...queryToggles
  }
  Vue.component('feature-toggle', () => import('./feature-toggle.vue'))

  const featureToggle = {
    toggles,
    queryString,
    queryStringPrefix,
    isQueryStringAllowed: (fn) => {
      featureToggle.isQueryStringAllowedFn = fn
    }
  }

  ctx.$featureToggle = featureToggle
  inject('featureToggle', featureToggle)
}
